import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { titleStyler, toShortNumber } from "../../../lib/util";

interface ScatterPlotProps {
  chartData: any[];
  legend?: string[];
  xLabel?: string;
  yLabel: string;
  title?: string;
  numberOfCategories: number;
  jumpToProposal?: Function;
  decisionBoundary?: any;
  includeDecisionB?: any;
  type: "line" | "scatter";
  xtype?: string;
}

const ScatterPlotChart = (props: ScatterPlotProps) => {
  const {
    xLabel,
    yLabel,
    title,
    numberOfCategories,
    chartData,
    legend,
    jumpToProposal,
    decisionBoundary,
    includeDecisionB,
    type,
    xtype,
  } = props;

  // let [axisTitleStyle, chartTitleStyle, axisLabelStyle, markerSize] =
  //   titleStyler();

  let { axisTitleStyle, axisLabelStyle, markerSizewDecisonB } = titleStyler();

  let series: any[] = [];

  if (numberOfCategories > 1) {
    chartData.forEach((item, index) => {
      series.push({
        name: legend![index],
        data: item,
        type: "scatter",
      });
    });
    // series = chartData;
  } else {
    series.push({
      data: chartData,
    });
  }

  if (decisionBoundary && includeDecisionB === "True") {
    if (decisionBoundary.length > 0) {
      let dbData = decisionBoundary[0].Data;
      console.log(dbData);
      for (let i = 0; i < dbData.length; i++) {
        let lineDta = dbData[i].map((d: any) => {
          return {
            x: d[0],
            y: d[1],
          };
        });
        series.push({
          name: "Decision Boundary" + (i + 1).toString(),
          type: "line",
          data: lineDta,
        });
      }
    }
    console.log(decisionBoundary);
    console.log(series);
  }

  let options = {
    chart: {
      height: 500,
      type: "line",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: xLabel,
            headerValue: yLabel,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
      events: {
        click: jumpToProposal
          ? (event: any, chartContext: any, config: any) =>
              jumpToProposal(
                config.config.series[config.seriesIndex].data[
                  config.dataPointIndex
                ].z
              )
          : undefined,
      },
    },
    fill: {
      type: "solid",
    },
    markers: {
      // size: markerSize,
      size: markerSizewDecisonB,
    },
    xaxis: {
      tickAmount: 10,
      type: xtype ? xtype : "numeric",
      title: {
        text: xLabel,
        offsetX: 0,
        offsetY: 70,
        style: axisTitleStyle,
      },
      labels: {
        style: axisLabelStyle,
        formatter: toShortNumber,
      },
    },
    yaxis: {
      tickAmount: 7,
      type: "numeric",
      title: {
        text: yLabel,
        offsetY: 0,
        style: axisTitleStyle,
        offsetX: 5,
      },
      labels: {
        style: axisLabelStyle,
        formatter: toShortNumber,
      },
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    tooltip: {
      shared: false,
      intersect: true,
      fixed: {
        enabled: true,
        position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60,
      },
      followCursor: true,
      z: {
        title: "Proposal ID: ",
      },
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
    },
    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ReactApexChart
        series={series}
        options={options as unknown as ApexOptions}
        type={type}
      />
    </div>
  );
};

export default ScatterPlotChart;
